import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { profileQKeys } from "@hooks/queries/profile/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


interface CreateSpecialtyData {
  name: string;
  description: string;
}

export const useCreateSpecialty = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (specialtyData: CreateSpecialtyData) => {
      return api.post("profile/specialty", specialtyData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },
    onSuccess: () => {
      showSuccessNotification({
        title: "success",
        message: "specialty-created-successfully",
      });

      // Invalidate specialties query to refetch the updated list
      queryClient.invalidateQueries({
        queryKey: profileQKeys.specialties(),
      });
    },

    onError: (res: any) => {
      console.error("[From Create Specialty]", res);
      handleErrors(res, "mutation");
    },
  });
};
